import React, { Component } from 'react';
import {
  Text,
  View,
  Dimensions,
  Alert,
  TouchableOpacity,
  StyleSheet,
  Platform,
  ActivityIndicator,
} from '../src/web/react-native';
import Icon from '../src/components/Icon';
import Pdf from '../src/components/Pdf';
import Modal from '../src/components/BaseModal';
import TakeOverSubmit from './TakeOver/takeOverSubmit';
import Service from './../Service/service';
import { connect } from 'react-redux';
import {
  UpdateShiftLogActionAsync,
  UpdateTeamShiftLogActionAsync,
  GetShiftLogsActionAsync,
  GetTeamShiftLogsActionAsync,
} from './../Action/ShiftLogAction';
import { LoadingOverlay, NavBar } from '../src/components';
import { shiftLogActions } from '../src/store';
import moment from 'moment';
import { Route } from '../src/app/Route';
import { ProgressView } from '../src/components/ProgressView';
import { DdLogs } from '../src/logging/datadog';

export class LogDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orientation: '',
      pdfWidth: Dimensions.get('window').width,
      pdfHeight: Dimensions.get('window').height,
      isTakeOverShow: false,
      rowData: [],
      fileContent: '',
      item: this.props.route.params.item,
      isDownloading: false,
    };
    this.scrollViewRefObj = null;
    this.rootView = React.createRef();
  }

  refreshShiftLogs = async () => {
    const preferences = await Service.getLocalPreferences();
    this.props.RefreshShiftLogs(preferences, this.props.route.params.isTeamLog);
  };

  getOrientation = () => {
    if (this.rootView.current) {
      if (Dimensions.get('window').width < Dimensions.get('window').height) {
        this.setState({ orientation: 'portrait' });
      } else {
        this.setState({ orientation: 'landscape' });
      }
    }
  };
  getTakeOver = async () => {
    this.setState({
      isTakeOverShow: true,
    });
    DdLogs.info('get take over is clicked');
    // let { approveTime, approveUser,
    //   assetName, createTime, createUser, fileContent, filename, path,
    //   shiftEnd, shiftStart, shiftSummaryID, status, submitTime, submitUser,
    //   takeoverDisplay, takeoverTime, takeoverUser, templateName
    // } = this.props.item
    let { takeoverDisplay } = this.props.route.params.item;
    DdLogs.info('takoverDisplay' + takeoverDisplay);
    if (takeoverDisplay) {
      let { site } = await Service.getLocalPreferences();
      let siteCode = site.siteCode;

      let { shiftSummaryID } = this.props.route.params.item;
      this.props
        .GetTakeOverDetails(siteCode, shiftSummaryID)
        .then((res) => {
          let data = res.payload.data;
          if (data && Object.keys(data).length > 0) {
            // Large payload — not logged to keep Datadog cost down.
            // DdLogs.info('call back data' + JSON.stringify(data));
            this.setState({
              rowData: data.rowData,
            });
          }
        })
        .catch((_err) => {
          setTimeout(() => {
            Alert.alert('Error', 'Unable to take over the log, please try again later.', [
              {
                text: 'OK',
                onPress: () => {},
              },
            ]);
          }, 200);
        });
    }
  };
  handleScrollTo = (p) => {
    if (this.scrollViewRefObj) {
      this.scrollViewRefObj.scrollTo(p);
    }
  };

  setScrollOffset = (offsetY) => {
    this.setState({
      scrollOffset: offsetY,
    });
  };
  closeModal = (isVisible) => {
    this.setState({
      isTakeOverShow: isVisible,
    });
  };
  async requestPDF() {
    let { site } = await Service.getLocalPreferences();
    let siteCode = site.siteCode;
    let { shiftSummaryID, lastUpdate, fileStatus } = this.props.route.params.item;
    this.setState({ isDownloading: true });
    if (this.props.route.params.isTeamLog) {
      DdLogs.info('log details.js teamlogs, lastUpdate:' + lastUpdate);
      this.props
        .UpdateTeamShiftLog(siteCode, shiftSummaryID, lastUpdate)
        .then((data) => {
          DdLogs.info('after update teamshiftlogs: ' + this.props.route.params.item.fileStatus);
          this.setState({
            item: { ...this.state.item, ...(data || {}) },
            isDownloading: false,
          });
          // this.props.route.params.setDownloadStatus("Downloaded");
        })
        .catch((err) => {
          DdLogs.error('Failed to update team shift logs', err);
          this.setState({ isDownloading: false });
          setTimeout(() => {
            Alert.alert('Error', 'Unable to request pdf, please try again later.');
          }, 200);
        });
    } else {
      this.props
        .UpdateShiftLog(siteCode, shiftSummaryID, lastUpdate)
        .then((data) => {
          this.setState({
            item: { ...this.state.item, ...(data || {}) },
            isDownloading: false,
          });
          // this.props.route.params.setDownloadStatus("Downloaded");
        })
        .catch((err) => {
          DdLogs.error('Failed to update shift log', err);
          this.setState({ isDownloading: false });
          setTimeout(() => {
            Alert.alert('Error', 'Unable to update shift logs, please try again later.');
          }, 200);
        });
    }
  }
  componentDidMount() {
    const item = this.props.route.params?.item;
    this.requestPDF();
    // Orientation.lockToLandscape();
    this.getOrientation();
    Dimensions.addEventListener('change', () => {
      this.getOrientation();
      this.setState({
        pdfWidth: Dimensions.get('window').width,
        pdfHeight: Dimensions.get('window').height,
      });
    });
    this.focusLogDetailListener = this.props.navigation.addListener('focus', async () => {
      // console.log('did focus in teamlog page.................')
      this.setState({});
    });
  }
  unsubmitShiftLog = async () => {
    const { site } = await Service.getLocalPreferences();
    const { shiftSummaryID } = this.props.route.params.item;
    this.props
      .UnsubmitShiftLog(site.siteCode, shiftSummaryID)
      .then((response) => {
        const { status } = response.payload;
        if (status) {
          Alert.alert(
              'Successfully Completed',
              'The shift log has been successfully unsubmitted.',
              [
                {
                  text: 'OK',
                  onPress: () => {
                    this.refreshShiftLogs();
                    this.props.navigation.navigate(Route.reportScreen);
                  },
                },
              ],
            );
        } else {
          Alert.alert('Error', 'Unable to unsubmit the shift log, please try again later.'); // Potentially switch to using the 'res.message' upon businesses request
        }
      })
      .catch((_err) => {
        Alert.alert('Error', 'Unable to unsubmit the shift log, please try again later.');
      });
  };
  render() {
    let { status, takeoverDisplay, shiftSummaryID, fileContent, submitTime, shiftStart, shiftEnd } =
      this.state.item;
    const shiftLogSubmittedDuringShift =
      moment(submitTime).isSameOrAfter(shiftStart) && moment(submitTime).isSameOrBefore(shiftEnd);
    //TODO: user restriction will be added back once the backend returns a valid user
    const canUnSubmitShiftLog = status === 'Submitted' && shiftLogSubmittedDuringShift;
    const source = fileContent
      ? {
          uri: 'data:application/pdf;base64,' + fileContent,
        }
      : {};

    return (
      <View ref={this.rootView} style={{ flex: 1 }}>
        {
          <LoadingOverlay
            visible={this.state.isDownloading}
            overlayColor="rgba(255, 255, 255, 0.88)"
            color="#222"
          />
        }
        <Modal
          animationType="slide"
          isVisible={this.state.isTakeOverShow}
          propagateSwipe={true}
          swipeDirection={['down']}
          scrollTo={this.handleScrollTo}
          scrollOffset={this.state.scrollOffset}
          scrollOffsetMax={400 - 300} // content height - ScrollView height
        >
          <TakeOverSubmit
            closeModal={this.closeModal}
            scrollViewRef={(e) => (this.scrollViewRefObj = e)}
            setScrollOffset={this.setScrollOffset}
            takeoverDisplay={takeoverDisplay}
            rowData={this.state.rowData}
            shiftSummaryID={shiftSummaryID}
            navigation={this.props.navigation}
            isTeamLog={this.props.route.params.isTeamLog}
            // item={this.props.route.params.item}
            item={this.state.item}
          />
        </Modal>
        <NavBar
          title="Log Reports"
          leftButton={
            <TouchableOpacity
              onPress={() => {
                this.props.navigation.navigate(Route.reportScreen, {
                  previousScreen: Route.logDetailsScreen,
                });
              }}
              style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
              <Icon name="arrow-back" size={30} color="#fff" />
            </TouchableOpacity>
          }
        />

        <View
          style={[
            { flex: 8 },
            this.state.orientation === 'portrait'
              ? styles.portraitContainer
              : styles.landscapeContainer,
          ]}>
          <Pdf
            source={source}
            fitPolicy={0}
            renderActivityIndicator={() => (
              <ActivityIndicator
                animating
                size="large"
                style={{ flex: 2, margin: 'auto' }}
                color="#222"
              />
            )}
            onLoadComplete={(numberOfPages, filePath) => {}}
            onPageChanged={() => {}}
            onError={(error) => {
              DdLogs.error('pdf error handler', error);
            }}
            onPressLink={() => {
              // console.log(`Link presse: ${uri}`)
            }}
            style={{ flex: 1, width: '100%', alignSelf: 'stretch' }}
          />
          {status === 'Submitted' && !!fileContent && (
            <>
              {canUnSubmitShiftLog && (
                <View
                  style={{
                    height: 48,
                    width: '95%',
                    alignSelf: 'center',
                    backgroundColor: '#a7a7a7',
                    borderRadius: 4,
                    position: 'absolute',
                    zIndex: 10,
                    bottom: Platform.OS === 'ios' ? 90 : 65,
                    shadowColor: 'black',
                    shadowOffset: { width: 3, height: 3 },
                    shadowOpacity: 0.8,
                    elevation: Platform.OS === 'android' && 5,
                  }}>
                  <TouchableOpacity
                    style={[{ flex: 1, justifyContent: 'center', alignItems: 'center' }]}
                    onPress={() => this.unsubmitShiftLog()}>
                    <Text style={{ color: '#fff', fontWeight: 'bold' }}>Unsubmit</Text>
                  </TouchableOpacity>
                </View>
              )}
              <View
                style={{
                  height: 48,
                  width: '95%',
                  alignSelf: 'center',
                  backgroundColor: '#0C479D',
                  borderRadius: 4,
                  position: 'absolute',
                  zIndex: 10,
                  bottom: Platform.OS === 'ios' ? 30 : 10,
                  shadowColor: 'black',
                  shadowOffset: { width: 3, height: 3 },
                  shadowOpacity: 0.8,
                  elevation: Platform.OS === 'android' && 5,
                }}>
                <TouchableOpacity
                  style={[{ flex: 1, justifyContent: 'center', alignItems: 'center' }]}
                  onPress={() => this.getTakeOver()}>
                  <Text style={{ color: '#fff', fontWeight: 'bold' }}>Take Over</Text>
                </TouchableOpacity>
              </View>
            </>
          )}
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  portraitContainer: {
    flex: 1,
    alignItems: 'stretch',
  },
  portraitPdf: {
    flex: 1,
    width: Dimensions.get('window').width,
    height: Dimensions.get('window').height,
  },

  landscapeContainer: {
    flex: 1,
    alignItems: 'stretch',
  },
  landscapePdf: {
    // flex:1,
    width: Dimensions.get('window').width,
    height: Dimensions.get('window').height,
  },
});
const mapStateToProps = (state) => ({
  shiftLogs: state.shiftLogs.shiftLogs,
  teamShiftLogs: state.shiftLogs.teamShiftLogs,
  isLoading: state.shiftLogs.isLoading,
  currentUser: state.user.user?.name,
  preference: state.preference.preferences,
});

const mapDispatchToProps = (dispatch) => {
  return {
    UpdateShiftLog: (siteCode, shiftSummaryID, lastUpdate) => {
      return dispatch(
        UpdateShiftLogActionAsync({
          siteCode,
          shiftSummaryID,
          lastUpdate,
        }),
      );
    },
    UpdateTeamShiftLog: (siteCode, shiftSummaryID, lastUpdate) => {
      return dispatch(
        UpdateTeamShiftLogActionAsync({
          siteCode,
          shiftSummaryID,
          lastUpdate,
        }),
      );
    },
    GetTakeOverDetails: (siteCode, shiftSummaryID) => {
      return dispatch(
        shiftLogActions.getShiftLogTakeOverDetails({
          siteCode: siteCode,
          shiftSummaryID: shiftSummaryID,
        }),
      );
    },
    UnsubmitShiftLog: (siteCode, shiftSummaryID) => {
      return dispatch(
        shiftLogActions.unsubmitShiftLog({
          siteCode: siteCode,
          shiftSummaryID: shiftSummaryID,
        }),
      );
    },
    RefreshShiftLogs: (preference, isTeamLog) => {
      const payload = {
        siteCode: preference.site.siteCode,
        assetName: Service.getShiftLogAssetName(preference),
      };
      if (isTeamLog) {
        return dispatch(GetTeamShiftLogsActionAsync(payload));
      } else {
        return dispatch(GetShiftLogsActionAsync(payload));
      }
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LogDetails);